document.addEventListener('DOMContentLoaded', function () {
  // Plantstrong custom JS

  // ── Klaviyo Back-in-Stock modal ──
  // Shared controller. Any OOS trigger calls window.PSBackInStock.open(variantId);
  // we create a client-side back-in-stock subscription via the Klaviyo public key.
  // Defined FIRST so the global exists even if a later block in this callback throws.
  (function () {
    var modal = document.getElementById('ps-bis-modal');
    if (!modal) return;

    var publicKey  = modal.dataset.publicKey;
    var dialog     = modal.querySelector('.ps-bis-dialog');
    var form       = modal.querySelector('.ps-bis-form');
    var emailInput = modal.querySelector('.ps-bis-email');
    var submitBtn  = modal.querySelector('.ps-bis-submit');
    var messageEl  = modal.querySelector('.ps-bis-message');
    var currentVariantId = null;
    var lastFocused = null;
    var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

    function setMessage(text, type) {
      messageEl.textContent = text || '';
      messageEl.className = 'ps-bis-message' + (type ? ' ps-bis-message--' + type : '');
    }

    function open(variantId) {
      if (!variantId) return;
      currentVariantId = String(variantId);
      lastFocused = document.activeElement;
      form.reset();
      setMessage('', null);
      submitBtn.disabled = false;
      submitBtn.textContent = 'Notify me';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ps-bis-lock');
      setTimeout(function () { emailInput.focus(); }, 50);
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ps-bis-lock');
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-bis-close')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      // Focus trap: keep Tab focus inside the dialog (honors aria-modal).
      if (e.key === 'Tab') {
        var focusable = Array.prototype.filter.call(
          dialog.querySelectorAll('button, input, select, textarea, a[href], [tabindex]:not([tabindex="-1"])'),
          function (el) { return !el.disabled && el.offsetParent !== null; }
        );
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput.value.trim();
      if (!EMAIL_RE.test(email)) {
        setMessage('Please enter a valid email address.', 'error');
        emailInput.focus();
        return;
      }
      if (!currentVariantId) {
        setMessage('Something went wrong. Please try again.', 'error');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
      setMessage('', null);

      var payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: { type: 'catalog-variant', id: '$shopify:::$default:::' + currentVariantId }
            }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(publicKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2026-04-15' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (res.ok) { // 202 Accepted on success
            setMessage("You're on the list! We'll email you when it's back in stock.", 'success');
            submitBtn.textContent = 'Done';
            submitBtn.disabled = true;
          } else {
            throw new Error('HTTP ' + res.status);
          }
        })
        .catch(function () {
          setMessage('Sorry, something went wrong. Please try again.', 'error');
          submitBtn.disabled = false;
          submitBtn.textContent = 'Notify me';
        });
    });

    window.PSBackInStock = { open: open, close: close };
  })();

  // ── Sticky ATC ──
  var stickyBar   = document.getElementById('ps-sticky-atc');
  var productMain = document.querySelector('.ps-product-main');
  if (stickyBar && productMain) {
    var mainForm       = productMain.querySelector('.product-form');
    var variantIdInput = mainForm && mainForm.querySelector('.variant-id-input');
    var variantsEl     = mainForm && mainForm.querySelector('.product-variants-json');

    if (mainForm && variantIdInput && variantsEl) {
      var variants     = JSON.parse(variantsEl.textContent);
      var stickyPrice  = stickyBar.querySelector('.sticky-price');
      var stickyCompare = stickyBar.querySelector('.sticky-compare-at-price');
      var stickyBtn    = stickyBar.querySelector('.sticky-atc-btn');
      var stickySelects = Array.from(stickyBar.querySelectorAll('.sticky-option-select'));

      function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      function currentVariant() {
        var id = parseInt(variantIdInput.value, 10);
        return variants.find(function (v) { return v.id === id; }) || null;
      }

      function syncStickyUI() {
        var variant = currentVariant();
        if (!variant) {
          // No matching variant (e.g. main form cleared the id): don't let the
          // sticky bar add to cart or open BIS against a stale variant id.
          if (stickyBtn) {
            stickyBtn.disabled    = true;
            stickyBtn.textContent = 'Unavailable';
            stickyBtn.classList.remove('sticky-atc-btn--bis');
          }
          return;
        }

        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
        if (stickyCompare) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            stickyCompare.textContent = formatMoney(variant.compare_at_price);
            stickyCompare.style.display = '';
          } else {
            stickyCompare.style.display = 'none';
          }
        }

        if (stickyBtn) {
          // Out-of-stock → Back-in-Stock trigger (clickable), mirroring the main form.
          stickyBtn.disabled    = false;
          stickyBtn.textContent = variant.available ? 'Add to Cart' : 'Notify me when back in stock';
          stickyBtn.classList.toggle('sticky-atc-btn--bis', !variant.available);
        }

        stickySelects.forEach(function (sel) {
          var idx = parseInt(sel.dataset.optionIndex, 10);
          var val = variant.options[idx];
          if (val && sel.value !== val) sel.value = val;
        });
      }

      // Poll for variant changes from main form pills (value= assignment isn't caught by MutationObserver)
      var lastVariantId = variantIdInput.value;
      setInterval(function () {
        if (variantIdInput.value !== lastVariantId) {
          lastVariantId = variantIdInput.value;
          syncStickyUI();
        }
      }, 150);

      // Sticky select → click matching pill in main form
      stickySelects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          var pill = mainForm.querySelector(
            '.variant-option[data-option-index="' + sel.dataset.optionIndex + '"] .pill[data-value="' + sel.value + '"]'
          );
          if (pill) pill.click();
        });
      });

      // Sticky ATC submit
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var variantId = variantIdInput.value;
          if (!variantId) return;

          // BIS mode: open the Back-in-Stock modal instead of adding to cart.
          if (stickyBtn.classList.contains('sticky-atc-btn--bis')) {
            if (window.PSBackInStock) window.PSBackInStock.open(variantId);
            return;
          }

          stickyBtn.disabled    = true;
          stickyBtn.textContent = 'Adding...';

          // Sticky bar reuses the main form. Gate on the StayAI purchaseType radio
          // (NOT the plan <select> value, which Safari / iOS WebKit can restore from
          // autofill/bfcache to a stale plan id while One-Time is selected). Only then
          // read the plan id from the in-form select.
          var payload = { id: variantId, quantity: 1 };
          var purchaseType = mainForm.querySelector('input[name="purchaseType"]:checked');
          var isSubscription = !!(purchaseType && /subscription/i.test(purchaseType.value));
          var sellingPlanSelect = mainForm.querySelector('select[name="stayai_selling_plan"]');
          if (isSubscription && sellingPlanSelect && sellingPlanSelect.value) {
            payload.selling_plan = sellingPlanSelect.value;
          }

          fetch('/cart/add.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body:    JSON.stringify(payload)
          })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var cartEvent = new Event('cart:update', { bubbles: true });
            cartEvent.detail = { resource: data };
            document.dispatchEvent(cartEvent);

            var drawer = document.querySelector('cart-drawer-component');
            if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();

            syncStickyUI();
          })
          .catch(function () {
            syncStickyUI();
          });
        });
      }

      // Show bar when .ps-product-main scrolls out of view
      var io = new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      io.observe(productMain);

      syncStickyUI();
    }
  }

});
